import { render, staticRenderFns } from "./l30.vue?vue&type=template&id=2c0dfae4&scoped=true&"
import script from "./l30.vue?vue&type=script&lang=js&"
export * from "./l30.vue?vue&type=script&lang=js&"
import style0 from "./l30.vue?vue&type=style&index=0&id=2c0dfae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0dfae4",
  null
  
)

export default component.exports